import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'About', id: 'about' },
    { label: 'Services', id: 'services' },
    { label: 'Gallery', id: 'gallery' },
    { label: 'Team', id: 'team' },
    { label: 'Reviews', id: 'testimonials' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <header
      data-testid="site-header"
      className={`relative z-40 transition-all duration-500 ${
        isScrolled
          ? 'bg-black/98 backdrop-blur-2xl border-b border-[#c9a961]/30 shadow-[0_4px_30px_rgba(201,169,97,0.1)]'
          : 'bg-black'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="text-2xl font-bold tracking-wider">
            <span className="font-['Playfair_Display'] text-[#c9a961] text-3xl font-medium">Balayage</span>
            <span className="font-['Playfair_Display'] text-[#f8f6f0] text-3xl ml-2 font-light">Vancouver</span>
          </div>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center space-x-8">
          {navItems.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-link-${item.id}`}
              onClick={() => scrollToSection(item.id)}
              className="text-[#f8f6f0]/80 hover:text-[#c9a961] transition-colors duration-300 text-sm font-medium tracking-wide"
            >
              {item.label}
            </button>
          ))}
          <Button
            data-testid="header-book-cta"
            onClick={() => window.open('https://www.fresha.com/a/prep-beauty-parlour-vancouver-1305-burrard-street-hlh2s5oh', '_blank')}
            className="bg-gradient-to-r from-[#c9a961] to-[#8b6f3e] hover:from-[#d4af37] hover:to-[#c9a961] text-black font-semibold px-8 py-2 rounded-none transition-all duration-300 hover:shadow-[0_0_40px_rgba(201,169,97,0.5)] hover:scale-105"
          >
            Book Now
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button
          data-testid="hamburger-toggle"
          aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
          className="lg:hidden text-[#f5f5f0] p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div data-testid="mobile-menu" className="lg:hidden bg-black/98 backdrop-blur-xl border-t border-[#d4af37]/20">
          <div className="px-6 py-6 space-y-4">
            {navItems.map((item) => (
              <button
                key={item.id}
                data-testid={`mobile-nav-link-${item.id}`}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left text-[#f5f5f0]/80 hover:text-[#d4af37] transition-colors duration-300 py-2 text-base"
              >
                {item.label}
              </button>
            ))}
            <Button
              data-testid="mobile-header-book-cta"
              onClick={() => window.open('https://www.fresha.com/a/prep-beauty-parlour-vancouver-1305-burrard-street-hlh2s5oh', '_blank')}
              className="w-full bg-[#d4af37] hover:bg-[#b8941f] text-black font-semibold py-3 rounded-none"
            >
              Book Now
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
